import { InteractionComponent } from './interaction_component';
import { Utils } from '../utils';
export class ActivityDefinition {
    name;
    type;
    description;
    moreInfo;
    extensions;
    interactionType;
    correctResponsesPattern;
    choices;
    scale;
    source;
    target;
    steps;
    constructor(cfg = {}) {
        const { name, type, description, moreInfo, extensions, correctResponsesPattern, interactionType } = cfg;
        const makeComponent = (items) => {
            if (items === undefined) {
                return [];
            }
            const rv = items.map((item) => {
                if (item instanceof InteractionComponent) {
                    return item;
                }
                return new InteractionComponent(item);
            });
            return rv;
        };
        this.interactionType = interactionType;
        switch (interactionType) {
            case 'choice':
            case 'sequencing':
                if (cfg.choices) {
                    this.choices = this.choices || [];
                    this.choices = [...this.choices, ...makeComponent(cfg.choices)];
                }
                break;
            case 'likert':
                if (cfg.scale) {
                    this.scale = this.scale || [];
                    this.scale = [...this.scale, ...makeComponent(cfg.scale)];
                }
                break;
            case 'matching':
                if (cfg.source) {
                    this.source = this.source || [];
                    this.source = [...this.source, ...makeComponent(cfg.source)];
                }
                if (cfg.target) {
                    this.target = this.target || [];
                    this.target = [...this.target, ...makeComponent(cfg.target)];
                }
                break;
            case 'performance':
                if (cfg.steps) {
                    this.steps = this.steps || [];
                    this.steps = [...this.steps, ...makeComponent(cfg.steps)];
                }
                break;
        }
        this.name = name;
        this.type = type;
        this.description = description;
        this.moreInfo = moreInfo;
        this.extensions = extensions;
        this.correctResponsesPattern = correctResponsesPattern;
    }
    toString(lang = 'en-US') {
        if (this.name !== null) {
            return this.getLangDictionaryValue('name', lang);
        }
        if (this.description !== null) {
            return this.getLangDictionaryValue('description', lang);
        }
        return '';
    }
    asVersion(version = '1.0.3') {
        const { name, type, description, interactionType, correctResponsesPattern, extensions } = this;
        const { choices, scale, source, target, steps } = this;
        const result = {
            name,
            type,
            description,
            interactionType,
            correctResponsesPattern,
            extensions,
            choices: choices && choices.map((v) => v.asVersion(version)),
            scale: scale && scale.map((v) => v.asVersion(version)),
            source: source && source.map((v) => v.asVersion(version)),
            target: target && target.map((v) => v.asVersion(version)),
            steps: steps && steps.map((v) => v.asVersion(version))
        };
        return result;
    }
    getLangDictionaryValue = Utils.getLangDictionaryValue;
    static fromJSON(definitionJSON) {
        const _definition = JSON.parse(definitionJSON);
        return new ActivityDefinition(_definition);
    }
}
